import { useNavigate } from "react-router-dom";
import {
  Close,
  NewEyeIcon,
  PDF,
} from "../../components/icons/Icon";
import { CloseIcon } from "../../components/icons/Icon2";
import Button from "../../components/updatedComponents/Dealers/Button";
import styles from "../dashboard/Dispatch.module.css";

const DownloadInvoicesModal = ({ mode, closeModal, invoices }) => {
  const navigate = useNavigate();

  return (
    <div
      className={styles.pack_order_modal}
      style={{ backgroundColor: mode && "#232529" }}
    >
      <div className={styles.header}>
        <p style={{ color: mode && "#FFFFFF" }}>Download Invoice</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div
        className={`${styles.media_con} ${styles.scroll} ${
          mode ? styles.scroll_dark : {}
        }`}
      >
        {invoices?.map((i, index) => (
          <div
            className={styles.invoice}
            style={{ backgroundColor: mode && "#1B1D21" }}
            key={i._id}
          >
            <div>
              <PDF />
              <p style={{ color: mode && "#FFFFFF" }}>
                {i.invoice.split("/").pop()}
              </p>
            </div>

            <div>
              <div
                style={{ backgroundColor: "#000000" }}
                onClick={() => navigate("/invoices/viewpdf?pdf=" + i.invoice)}
              >
                <NewEyeIcon />
              </div>

              {/* <div
                style={{ backgroundColor: "#4164E3" }}
                onClick={async () => await downloadFile(i.invoice)}
              >
                <DownloadSmall />
              </div> */}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.bottom_btns}>
        <Button
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonText={"Close"}
          buttonIcon={<Close />}
          buttonClick={closeModal}
        />
      </div>
    </div>
  );
};

export default DownloadInvoicesModal;
